/** Yala Delivery Customer Terms — versioned legal copy. */

export const CUSTOMER_TERMS_VERSION = "v1.1";
export const CUSTOMER_PRIVACY_VERSION = "v1.0";

export const CUSTOMER_TERMS_SECTIONS = [
  {
    id: 1,
    title: "Acceptance",
    body: "By placing a delivery order with Yala Delivery, you agree to these Customer Delivery Terms.",
  },
  {
    id: 2,
    title: "Ordering & Accounts",
    bullets: [
      "You must provide accurate pickup, delivery, and contact details",
      "You are responsible for orders placed from your account",
      "Phone verification may be required before your first delivery",
      "You must be legally able to enter into this agreement",
    ],
  },
  {
    id: 3,
    title: "Delivery Services",
    intro: "Yala Delivery connects you with independent couriers for:",
    bullets: [
      "Package and document delivery",
      "Food, pharmacy, and store orders",
      "Scheduled and on-demand deliveries within supported cities",
    ],
  },
  {
    id: 4,
    title: "Pricing & Payment",
    bullets: [
      "Fares and fees are shown before you confirm an order",
      "Prices may include delivery fee, service fee, surge, and applicable taxes",
      "Payment is required before your delivery is created. Supported methods: Debit/Credit Card, Bankily, Sedad, and Masravi",
      "Promo codes apply only when valid and within their terms",
    ],
  },
  {
    id: 5,
    title: "PIN & Recipient Verification",
    bullets: [
      "A drop-off PIN may be sent to the recipient to confirm delivery",
      "Share pickup or drop-off PINs only with the assigned courier",
      "You are responsible for ensuring someone is available to receive the order",
    ],
  },
  {
    id: 6,
    title: "Prohibited Items",
    intro: "You may not request delivery of:",
    bullets: [
      "Illegal goods or substances",
      "Weapons or hazardous materials",
      "Items that violate Mauritanian law or Yala policy",
      "Live animals or other restricted products",
    ],
  },
  {
    id: 7,
    title: "Cancellations & Refunds",
    intro: "You may cancel before pickup subject to platform rules. Cancellation fees may apply after a courier is assigned or has arrived. Refunds for merchant orders follow store and Yala review policies.",
  },
  {
    id: 8,
    title: "Merchant Orders",
    intro: "Store orders are fulfilled by the merchant and delivered by a Yala courier. Product quality, substitutions, and preparation times are the merchant's responsibility. Report issues through in-app support.",
  },
  {
    id: 9,
    title: "Conduct",
    intro: "Customers must treat couriers and support staff respectfully. Abuse, fraud, or false reports may result in account suspension.",
  },
  {
    id: 10,
    title: "Liability",
    intro: "Yala is a technology platform and is not liable for:",
    bullets: [
      "Courier delays due to traffic, weather, or road conditions",
      "Incorrect addresses or contact details you provide",
      "Loss or damage caused by prohibited or improperly packaged items",
      "Force majeure events beyond reasonable control",
    ],
  },
  {
    id: 11,
    title: "Privacy",
    intro: "Yala collects order history, location data, contact information, and payment details to operate the service. See our privacy policy for how your data is used and protected.",
  },
  {
    id: 12,
    title: "Support & Disputes",
    intro: "Report delivery problems, missing items, or safety concerns through in-app support. Yala may review order details, chat, and proof before resolving disputes.",
  },
  {
    id: 13,
    title: "Updates",
    body: "Yala may update these customer terms at any time. Placing a new order after an update means you accept the revised terms.",
  },
];
